import {Injectable} from '@angular/core';
import {CacheService} from "@customcoding/shared";
import {Observable} from "rxjs";
import {AppointmentCategory} from "../models/appointment.model";

@Injectable({
	providedIn: 'root'
})
export class AppointmentCategoryService {

	constructor(
		private cache: CacheService
	) { }

	getAll(filter: string = ''): Observable<AppointmentCategory[]> {
		return this.cache.get(`/api/scap/appointment-category${filter}`);
	}
}
